<template>
  <div class="d-flex flex-column flex-sm-row pa-2 align-stretch align-sm-center">
    <v-select
      outlined
      hide-details
      v-model="status"
      :items="getStudentStatusList"
      dense
      label="Trạng thái sinh viên"
      item-text="label"
      item-value="value"
      class="filter-item"
      clearable
    ></v-select>
    <v-select
      clearable
      outlined
      hide-details
      v-model="rank"
      :items="getStudentRankList"
      dense
      label="Xếp loại sinh viên"
      item-text="label"
      item-value="value"
      class="filter-item mt-4 mt-sm-0 ml-0 ml-sm-2"
      @change="onRankChange"
    ></v-select>
    <v-select
      clearable
      outlined
      hide-details
      v-model="semester"
      :items="semester_configs"
      dense
      item-text="title"
      item-value="id"
      class="filter-item mt-4 mt-sm-0 ml-0 ml-sm-2"
      placeholder=" tất cả học kỳ"
      prefix="Học kỳ:"
      v-if="!!rank"
    ></v-select>

    <div class="flex-fill"></div>
    <v-btn
      depressed
      color="amber darken-1"
      @click="onFilterChanged"
      class="white--text ml-0 ml-sm-4 mt-4 mt-sm-0"
    >
      <v-icon left dark>mdi-filter-outline</v-icon>Lọc
    </v-btn>
  </div>
</template>
<script>
import { getStudentStatusList, getStudentRankList } from '@/helpers'
export default {
  props: {
    semester_configs: Array,
    defaultFilter: { type: Object, default: () => ({}) }
  },
  data() {
    return {
      status: this.defaultFilter.status || '',
      rank: this.defaultFilter.rank || '',
      semester: this.defaultFilter.semester || ''
    }
  },
  computed: {
    getStudentStatusList,
    getStudentRankList
  },
  methods: {
    onRankChange(v) {
      if (!v) {
        this.semester = ''
      }
    },
    onFilterChanged() {
      const payload = { status: this.status, rank: this.rank, semester: this.semester }
      for (const key in payload) {
        if (Object.hasOwnProperty.call(payload, key)) {
          const element = payload[key]
          if (!element && element !== 0) {
            delete payload[key]
          }
        }
      }

      this.$emit('filterChanged', payload)
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~vuetify/src/styles/styles.sass';

.filter-item:first-child {
  margin-left: 0px;
  margin-top: 0px;
}
@media #{map-get($display-breakpoints, 'sm-and-up')} {
  .filter-item {
    max-width: 300px;
  }
}
</style>
